import { MenuItem } from "@mui/material"
import { MRT_Row } from "material-react-table"
import { makeStyles } from "tss-react/mui"

import { ExternalServiceEntry } from "../extraServicesTypes"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { getExtraServiceRoute } from "../../../../../constants/routes"
import { tailwindPalette } from "../../../../theme/tailwindPalette"
import { DefaultConfirmModalStateType } from "./DeleteExtraServiceDialog"

export const useRowActionMenuItemsStyles = makeStyles()(() => ({
    deleteItem: {
        color: tailwindPalette.red[600],
    },
}))

type RenderRowActionMenuItemsProps = {
    row: MRT_Row<ExternalServiceEntry>
    closeMenu: () => void
    setConfirmModalState: React.Dispatch<React.SetStateAction<DefaultConfirmModalStateType>>
    navigate: (path: string) => void
    deleteItemClassName: string
}

export const renderRowActionMenuItems = ({
    row,
    closeMenu,
    setConfirmModalState,
    navigate,
    deleteItemClassName,
}: RenderRowActionMenuItemsProps) => [
    <LocalizedStrict id="products-edit-product-menu-item" key={`edit-${row.original.id}`}>
        <MenuItem
            onClick={() => {
                navigate(getExtraServiceRoute(row.original.id))
                closeMenu()
            }}
        >
            Edit
        </MenuItem>
    </LocalizedStrict>,
    <LocalizedStrict id="products-delete-product-menu-item" key={`delete-${row.original.id}`}>
        <MenuItem
            className={deleteItemClassName}
            onClick={() => {
                setConfirmModalState({
                    showConfirmModal: true,
                    confirmModalText: `${row.original.name}`,
                    productId: row.original.id,
                })
                closeMenu()
            }}
        >
            Delete
        </MenuItem>
    </LocalizedStrict>,
]
